
import EventBusConstants from '@/constants/EventBusConstants';
import { PauseType } from '@/controllers/pause/PauseManager';
import TestController from '@/controllers/TestController';
import { inject } from 'vue';
import { Vue } from 'vue-property-decorator';
import PlayerEmitter from '../../event/PlayerEmitter';
export default class PauseButton extends Vue {
  private testController: TestController | undefined = inject<TestController>('testController');
  private emitter: PlayerEmitter | undefined = inject('playerEmitter');
  private buttonClicked(): void {
    this.testController?.pauseManager?.pauseTest(PauseType.TESTER_PAUSE);
    this.emitter?.emit(EventBusConstants.PAUSE_BUTTON_CLICKED);
  }
}
